import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/ClientContext';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';

ThdAnalytics.init();
NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());
  client.render(
    <App
      recaptchaKey={client.expConfiguration.recaptchaKey}
      recaptchaV3Key={client.expConfiguration.recaptchaV3Key}
    />
  );
});
